import { Controller } from '@hotwired/stimulus';
import { fetchTurboStream } from '../../helpers/turbo_helper';

function batchRequestBody(elements) {
  const formData = new FormData();

  elements.forEach((element) => {
    formData.append('journeys[]', element.dataset.journeyKey);
  });

  return formData;
}

export default class PriceIndicationsLoaderController extends Controller {
  static targets = ['journeyLoading'];
  static values = {
    url: String
  };

  initialize() {
    this.intersectionObserver = new IntersectionObserver(
      this.handleIntersect.bind(this),
      {}
    );
    this.intersectingElements = [];
    this.loading = false;
    this.loadPending = false;
  }

  connect() {
    if (!this.initialLoadedValue) {
      // this.loadInitial();
    }
  }

  journeyLoadingTargetConnected(element) {
    this.intersectionObserver.observe(element);
  }

  journeyLoadingTargetDisconnected(element) {
    this.intersectionObserver.unobserve(element);
    this.removeIntersectingElement(element);
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.intersectingElements.push(entry.target);
      } else {
        this.removeIntersectingElement(entry.target);
      }
    });
    if (this.intersectingElements.length === 0) {
      return;
    }

    this.loadBatch();
  }

  removeIntersectingElement(element) {
    const index = this.intersectingElements.indexOf(element);
    if (index < 0) {
      return;
    }

    this.intersectingElements.splice(index, 1);
  }

  async loadBatch() {
    if (this.loading) {
      this.loadPending = true;
      return;
    }
    this.loading = true;

    const elementsToLoad = this.elementsToLoad();

    const response = await fetchTurboStream(this.urlValue, { method: 'POST', body: batchRequestBody(elementsToLoad) });
    this.loading = false;

    if (response.status === 429) {
      this.loadPending = false;
      setTimeout(() => {
        if (!this.loading) {
          this.loadBatch();
        }
      }, 3000);

      return;
    }

    elementsToLoad.forEach((element) => { element.dataset['journeySearch-PriceIndicationsLoaderTarget'] = ''; });

    if (this.loadPending) {
      this.loadPending = false;
      this.loadBatch();
    }
  }

  elementsToLoad() {
    const firstElementIndex = Math.min(
      ...this.intersectingElements.map((element) => this.journeyLoadingTargets.indexOf(element))
    );

    if (this.intersectingElements.length > 5) {
      this.loadPending = true;
    }

    return this.journeyLoadingTargets.slice(firstElementIndex, firstElementIndex + 5);
  }
}
